module.exports = __webpack_public_path__ + "img/bridge-logo.0523e70e.png";